'use strict';

export default class IssueHeader {
    constructor() {
        this.name = 'issueheader';

        let $selector   = $('.issue-selector'),
            $yearSelect = $('.issue-selector__year', $selector),
            $volSelect  = $('.issue-selector__volume', $selector),
            issuesLog   = [],
            endpoint    = '/api/MGSApi/GetIssueUrlByYearVolume';


        if(window.location.hostname === 'localhost' || window.location.hostname === 'prototype.mygreenspace.sg2lamp01.sys.adelphi.digital') {
            endpoint = '/ajax/issuelink.json';
        }

        issuesLog = window.issues;
        //issuesLogVolume = window.issuesVolume;

        $yearSelect.on('change', function(){
            $volSelect
                .val(0)
                .trigger('change');

            for(var i = 0; i < issuesLog.length; i++){
                if (issuesLog[i].year === $yearSelect.val()) {
                    var splitIssueList = issuesLog[i].issues[0].split(",");
                    var splitVolList = issuesLog[i].issuesLogVolume[0].split(",");
                    setVolumeOptions(splitIssueList, splitVolList);
                }
            }
        });

        $volSelect.on('change', function(){
            var vol = $(this).val();

            if(vol > 0) {
                getURL($yearSelect.val(), vol)
            }
        });

        function getURL(year, vol){
            var params = {
                "year": year,
                "volume": vol
            }

            $.ajax({
                url: endpoint,
                data: params
            }).done(function(e){
                if(e.Success) window.location.href = e.Url;
            });
        }

        function setVolumeOptions(issuesNum,volList) {
            var counter = 0,
                $optEl  = $('<option/>');

            // Clear options except for first option
            $volSelect.find('option').each(function(){
                if($(this).index() > 0) {
                    $(this).remove();
                }
            });

            while(counter < issuesNum.length ) {
                var $optEl = $('<option value = "' + volList[counter] + '"/>');
                if ($.isNumeric(issuesNum[counter])) {
                    $optEl.text('Volume ' + issuesNum[counter]);
                    $volSelect.append($optEl);
                }
                else {
                    $optEl.text(issuesNum[counter]);
                    $volSelect.append($optEl);
                }
              
               counter++;
            }
        }
    }
}
